/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Markdown } from 'react-showdown';
import DocumentationType from '../components/Type';
import { Source, Example } from '../components/Others';

export default function Class({ docs }) {
    const propertyIndex = [];
    const methodIndex = [];
    const properties = [];
    const methods = [];

    const ParameterInitializer = ({ params }) => {
        return <span style={{ opacity: .8 }}>({params.map(x => x.name).join(', ')})</span>;
    }

    for (const prop of docs.properties) {
        propertyIndex.push(<a style={{ cursor: 'pointer' }} onClick={() => document.getElementById(`p${prop.name}`).scrollIntoView()}>{prop.name}{' '}</a>);
        properties.push(
            <div style={{ marginTop: '25px' }}>
                <h2 id={`p${prop.name}`}>
                    .{prop.name} <Source sources={prop.sources}/> <Badge flags={prop.flags}/>
                </h2>

                <h3>Type: </h3>
                <div style={{ marginBottom: '-8px', marginTop: '2px' }}>
                    <DocumentationType type={prop.type}/>
                </div>

                <Markdown markdown={prop.comment?.shortText || 'No documentation found.'}/>
            </div>
        );
    }

    for (const method of docs.methods) {
        methodIndex.push(<a style={{ cursor: 'pointer' }} onClick={() => document.getElementById(`m${method.name}`).scrollIntoView()}>{method.name}{' '}</a>);
        methods.push(
            <div style={{ marginTop: '25px' }}>
                <h2 style={{ marginBottom: '-10px' }} id={`m${method.name}`}>
                    .{method.name}<ParameterInitializer params={method.params}/> <Source sources={method.sources}/> <Badge flags={method.flags}/>
                </h2>

                <Markdown markdown={method.comment?.shortText || 'No documentation found.'}/>
                <Example comment={method.comment}/>

                <h3>Returns: </h3>
                <div style={{ marginBottom: '10px' }}><DocumentationType type={method.returns}/></div>
                
                <h3>Parameters: </h3>
                <table>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Description</th>
                    </tr>
                    {method.params.map(x => <tr>
                        <td>{x.name}</td>
                        <td><DocumentationType type={x.type}/></td>
                        <td>{x.comment?.shortText} {x.flags.isOptional ? <div className="badge">OPTIONAL</div> : null}</td>
                    </tr>)}
                </table>
            </div>
        );
    }

    return <>
        <h1>
            {docs.name} <Source sources={docs.constructor.sources}/>
        </h1>

        {docs.extends ? <h3 style={{ marginTop: '10px' }}>extends <DocumentationType type={docs.extends}/></h3> : null}
        <Markdown markdown={docs.comment?.shortText || 'No documentation found.'}/>

        <hr style={{ marginTop: '15px' }}/>
        <h4>Properties:</h4> {propertyIndex}
        <h4>Methods:</h4> {methodIndex}
        <hr style={{ marginTop: '15px' }}/>

        <h2 style={{ marginBottom: '-10px' }} id="constructor">
            constructor<ParameterInitializer params={docs.constructor.params}/> <Source sources={docs.constructor.sources}/>
        </h2>

        <Markdown markdown={docs.constructor.comment?.shortText || 'No documentation found.'}/>
        <Example comment={docs.constructor.comment}/>

        <table>
            <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Description</th>
            </tr>
            {docs.constructor.params.map(x => <tr>
                <td>{x.name}</td>
                <td><DocumentationType type={x.type}/></td>
                <td>{x.comment?.shortText} {x.flags.isOptional ? <div className="badge">OPTIONAL</div> : null}</td>
            </tr>)}
        </table>

        {properties}
        {methods}
    </>
}

function Badge({ flags = {} }) {
    return <>
        {flags.isOptional ? <div className="badge">OPTIONAL</div> : null}
        {flags.isStatic ? <div className="badge">STATIC</div> : null}
    </>
}